import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import SurveyMarker from "../../components/TahoeMap/SurveyMarker";
import "./CitizenScience.css";

import MODULES from "../../static/modules.json";

function Litter() {
    const [[map_markers, setMapMarkers, active_location_idx, setActiveLocation],
        module_container, [reports]] = useOutletContext();
    
    let filtered_reports = reports?.[MODULES.CITIZEN_SCIENCE.TABS.LITTER.feature_layer];
    let reports_loading = filtered_reports === undefined;
    let reports_unavailable = filtered_reports === null;

    //////////////////////////////////////////////////////////
    // Set Map Markers
    //////////////////////////////////////////////////////////
    useEffect(() => {
        if (reports_unavailable || reports_loading) {
            setMapMarkers([]);
            return;
        }

        const markers = filtered_reports
            .map((r, idx) => {
                return <SurveyMarker
                    key={`litter-map-marker-${idx}`}
                    position={r.location}
                    survey_creation_date={r.survey_date}
                    survey_questions={r.survey_questions}
                    images={r.images}
                    />
            });

        setMapMarkers(markers);
    }, []);

    return (
        <div className="fill-parent citizen-science-msg">
            {
                (reports_loading) ? "Loading Citizen Science data" :
                (reports_unavailable) ? "Litter Data is temporarily unavailable" : ""
            }
        </div>
    );
}

export default Litter;